import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';
import docsInstructionSoleTrader from '~/assets/docs/portal_user_manual.pdf';
import docsInstructionLegalResident from '~/assets/docs/instruction_legal_resident.pdf';
import docsInstructionReIdentificationLegalResident from '~/assets/docs/instruction_re_legal_resident.pdf';
import docsInstructionProcessingPersonalClient from '~/assets/docs/instructions_processing_personal_data_client.pdf';
import instructionReIdentificationFop from '~/assets/docs/instruction_re_identification_fop.pdf';
import instructionCovenantsPDF from '~/assets/docs/instruction_covenants_web_portal.pdf';
import instructionRemoteBankingContactsPDF from '~/assets/docs/openInstructionRemoteBankingContacts.pdf';

export const mainPageInitialValues = () => ({
  dataUpdateForms: [] as TAutocompleteOption[],
});

export const handleRate = () => {
  window.open(
    'https://www.eximb.com/ua/business/klientam-msb/msb-current-account/dlya-jurydychnyh-osib-ta-fizychnyh-osib-pidpryemtsiv/'
  );
};
export const openInstructionSoleTraderPDF = () => safeWindowOpen(docsInstructionSoleTrader);
export const openInstructionLegalResident = () => safeWindowOpen(docsInstructionLegalResident);
export const openInstructionReIdentificationLegalResident = () =>
  safeWindowOpen(docsInstructionReIdentificationLegalResident);
export const openInstructionProcessingPersonalClient = () =>
  safeWindowOpen(docsInstructionProcessingPersonalClient);
export const openDirectoryOrgUa = () => window.open('https://directory.org.ua/');
export const openFatca = () => window.open('https://www.eximb.com/ua/bank/fatcacrs/fatca.html');
export const openCRS = () => window.open('https://tax.gov.ua/baneryi/crs');
export const openInstructionReIdentificationFopPDF = () =>
  safeWindowOpen(instructionReIdentificationFop);
export const openInstructionCovenantsPDF = () => safeWindowOpen(instructionCovenantsPDF);
export const openInstructionRemoteBankingContactsPDF = () =>
  safeWindowOpen(instructionRemoteBankingContactsPDF);
